<script setup>
  import Article from './Article.vue';

  defineProps({
    posts: Array,
  });
</script>
<template>
  <div class="items-wrapper">
    <Article v-for="post in posts" :post="post" header="h2" horizontal />
  </div>
</template>
<style scoped lang="scss">
  .items-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 4rem;
  }

  @media(max-width: 992px) {
    .items-wrapper {
      grid-template-columns: 1fr 1fr;
      gap: 0;

      .article-link-wrapper {
        padding: 1.5rem 1rem;
      }
    }
  }

  @media(max-width: 767px) {
    .items-wrapper {
      grid-template-columns: 1fr;

      .article-link-wrapper {
        &:nth-child(odd) {
          background-color: var(--color-light-gray);

          :deep(.article-wrapper .content-wrapper) {
            background-color: var(--color-light-gray);
          }
        }
      }
    }
  }
</style>
